import { DataService } from './dataService'


export const WebRetailerService ={
    getWebLinkRetailer: async (data) => {
        return DataService.get('/admin/retailer/list', data)
    },
    // editCategory: async (data) => {
    //     return DataService.delete('/admin/category/update', data)
    // },
    editRetailer: async (data) => {
        return DataService.put('/admin/retailer/update', data)
    },
	addWebRetailer: async (data) => {
        return DataService.post('/admin/retailer/create', data)
    },
	deleteWebRetailer: async (data) => {
        // return DataService.delete('/admin/retailer/delete?', data)
        let url = '/admin/retailer/delete'
        let str = DataService.convertObjToQueryStr(data)
	    url = url+str;
        return DataService.delete(url, data)
    },
    
}